import { createSelector } from '@reduxjs/toolkit'
import { getApproval } from '../../getters'

export const selectApproval = createSelector(
  [getApproval],
  (approval) => approval
)
